// import React from 'react';
// import { useSelector } from 'react-redux';
// import { SidebarImg } from '../../../static/constant/imgConstants';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch } from '@fortawesome/free-solid-svg-icons';
// import { FaWallet } from 'react-icons/fa';
// import { useNavigate } from 'react-router';

// const Header = () => {

//   const navigate = useNavigate()

//   const getUserInfoReducer = useSelector(state => state.getUserInfoReducer);


//   return (
//     <header className="w-full h-[6.5rem] flex justify-between items-center px-[2rem] py-[.8rem] bg-white border-b">
//       <div className="w-[20rem] mx-5">
//         <img className="w-full h-full" alt="" src={SidebarImg.logoNew} />
//       </div>

//       <div className="w-full flex justify-end items-center">
//         {/* <div className="flex justify-center items-center bg-[#96A3B6]/10 rounded-[0.3rem] mr-[10%]">
//           <FontAwesomeIcon icon={faSearch} size="2rem" color="#666666" className="p-[1.4rem]" />
//           <input
//             type="text"
//             placeholder="Search"
//             className="w-[21.5rem] h-full text-[1.6rem] border-none focus:outline-none bg-transparent"
//           />
//         </div> */}

//         <button
//           className='w-[8%] h-[4rem] flex justify-center items-center bg-[#0D9B50] hover:bg-[#6ec396] rounded-full mx-[2rem]'
//           onClick={() => { getUserInfoReducer.data.userType === "BRAND" ? navigate("/brand/transactions") : navigate("/influencer/transactions") }}
//         >
//           <FaWallet size={20} color='white' className="mx-1" />
//           <span className="text-[#ffffff] text-[1.4rem]">${getUserInfoReducer?.data?.walletBalance}</span>
//         </button>

//         {/* <button className='w-[6rem] h-[4rem] flex justify-evenly items-center bg-[#FD6C55] hover:bg-[#FD6D77] rounded-full mx-[2rem]'>
//           <img src={SidebarImg.notification} alt="notification-bell" className="w-[2rem] h-[2rem]" />
//           <span className="text-[#ffffff] text-[1.4rem]">2</span>
//         </button> */}

//         {/* User Info Section */}
//         <div className="flex items-center">
//           <div className="w-[3.6rem] h-[3.6rem] rounded-full mx-[2rem]">
//             <img className="w-full h-full rounded-full" src={SidebarImg.profile} alt="User Avatar" />
//           </div>
//           <span className="text-[1.5rem]">
//             {getUserInfoReducer?.data?.firstName} {/* Dynamic name from getUserInfoReducer?.data */}
//           </span>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SidebarImg } from '../../../static/constant/imgConstants';
import { useNavigate } from 'react-router';
import { FaWallet } from 'react-icons/fa';
import ProfilePanel from '../ProfilePanel/ProfilePanel';
import { getInfluencerProfileRequest } from '../../../store/authStore/actions/authActions/getInfluencerProfileActions';
import { getS3ImageUrl } from '../../../utils/imageUtils';

const Header = ({ onMenuToggle }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const getUserInfoReducer = useSelector(state => state.getUserInfoReducer);
    const getInfluencerProfileReducer = useSelector(state => state.getInfluencerProfileReducer);
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [imgSrc, setImgSrc] = useState(SidebarImg.profile);
    const [imgLoading, setImgLoading] = useState(false);

    const profilePhotoUrl = getInfluencerProfileReducer?.data?.profilePhotoUrl;

    useEffect(() => {
        if (profilePhotoUrl) {
            setImgSrc(getS3ImageUrl(profilePhotoUrl));
            setImgLoading(true);
        } else {
            setImgSrc(SidebarImg.profile);
            setImgLoading(false);
        }
    }, [profilePhotoUrl]);

    const isInfluencer = getUserInfoReducer?.data?.userType === 'INFLUENCER';

    // Fetch profile data on mount for all user types
    useEffect(() => {
        if (!getInfluencerProfileReducer?.data) {
            dispatch(getInfluencerProfileRequest());
        }
    }, [dispatch, getInfluencerProfileReducer?.data]);

    // Check if influencer profile is incomplete
    const isProfileIncomplete = isInfluencer && (() => {
        const d = getInfluencerProfileReducer?.data;
        if (!d) return true; // No profile data at all
        return !d.ageRange || !d.profileGender || !d.city || !d.language;
    })();

    const handleWalletClick = () => {
        getUserInfoReducer.data.userType === "AGENCY"
            ? navigate("/agency/transactions")
            : getUserInfoReducer.data.userType === "BRAND"
                ? navigate("/brand/transactions")
                : navigate("/influencer/transactions")
    };

    return (
        <header className="w-full h-[6.5rem] flex justify-between items-center px-[2rem] py-[.8rem] bg-white border-b">
            <div className="w-[20rem] mx-5">
                <img className="w-full h-full" alt="Logo" src={SidebarImg.logoNew} />
            </div>

            <div className="flex items-center">
                {/* Wallet and User Info for Larger Screens */}
                <div className="hidden w-full lg:flex justify-end items-center">
                    <button
                        className='w-auto md:w-[120px] h-[4rem] flex justify-center items-center bg-[#0D9B50] hover:bg-[#6ec396] rounded-full mx-[2rem]'
                        onClick={handleWalletClick}
                    >
                        <FaWallet size={20} color='white' className="mx-1" />
                        <span className="text-[#ffffff] text-[1.4rem]">
                            ${getUserInfoReducer?.data?.walletBalance}
                        </span>

                    </button>

                    {/* Clickable User Avatar/Name — Opens Profile Panel */}
                    <div
                        className="flex items-center cursor-pointer hover:opacity-80 transition-opacity"
                        onClick={() => setIsProfileOpen(true)}
                        title="View Profile"
                    >
                        <div className="w-[3.6rem] h-[3.6rem] rounded-full mx-[2rem] relative bg-gray-100 flex items-center justify-center overflow-hidden">
                            {imgLoading && (
                                <div className="absolute inset-0 flex items-center justify-center bg-white/50 z-10">
                                    <div className="w-4 h-4 border-2 border-[#0D9B50] border-t-transparent rounded-full animate-spin" />
                                </div>
                            )}
                            <img
                                className={`w-full h-full rounded-full object-cover transition-opacity duration-300 ${imgLoading ? 'opacity-0' : 'opacity-100'}`}
                                src={imgSrc}
                                alt="User Avatar"
                                onLoad={() => setImgLoading(false)}
                                onError={() => {
                                    setImgSrc(SidebarImg.profile);
                                    setImgLoading(false);
                                }}
                            />
                            {isProfileIncomplete && (
                                <span className="absolute top-0 right-0 w-[0.8rem] h-[0.8rem] bg-red-500 rounded-full border-2 border-white animate-pulse z-20" />
                            )}
                        </div>
                        <span className="text-[1.5rem]">
                            {getUserInfoReducer?.data?.firstName}
                        </span>
                    </div>
                </div>

                {/* Hamburger Menu for Mobile */}
                <div className="lg:hidden mr-4">
                    <button
                        onClick={onMenuToggle}
                        className="flex flex-col justify-center items-center w-10 h-10 space-y-1 bg-[#0D9B50] rounded-md p-2"
                    >
                        <span className="block w-6 h-0.5 bg-white"></span>
                        <span className="block w-6 h-0.5 bg-white"></span>
                        <span className="block w-6 h-0.5 bg-white"></span>
                    </button>
                </div>


            </div>

            {/* Profile Slide-out Panel */}
            <ProfilePanel
                isOpen={isProfileOpen}
                onClose={() => setIsProfileOpen(false)}
            />
        </header>
    );
};

export default Header;